export const Sales = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_300_3790)">
      <path
        d="M4.08333 8.16667C5.3725 8.16667 6.41667 7.1225 6.41667 5.83333C6.41667 4.54417 5.3725 3.5 4.08333 3.5C2.79417 3.5 1.75 4.54417 1.75 5.83333C1.75 7.1225 2.79417 8.16667 4.08333 8.16667ZM4.08333 4.66667C4.725 4.66667 5.25 5.19167 5.25 5.83333C5.25 6.475 4.725 7 4.08333 7C3.44167 7 2.91667 6.475 2.91667 5.83333C2.91667 5.19167 3.44167 4.66667 4.08333 4.66667ZM8.16667 11.0833V14H7V11.0833C7 10.7625 6.7375 10.5 6.41667 10.5H1.75C1.42917 10.5 1.16667 10.7625 1.16667 11.0833V14H0V11.0833C0 10.1208 0.7875 9.33333 1.75 9.33333H6.41667C7.37917 9.33333 8.16667 10.1208 8.16667 11.0833ZM14 1.75V10.5H9.275C9.1875 10.0683 8.995 9.67167 8.73833 9.33333H12.8333V1.75C12.8333 1.42917 12.5708 1.16667 12.25 1.16667H4.66667C4.34583 1.16667 4.08333 1.42917 4.08333 1.75V2.33333C3.675 2.33333 3.28417 2.40917 2.91667 2.5375V1.75C2.91667 0.7875 3.70417 0 4.66667 0H12.25C13.2125 0 14 0.7875 14 1.75ZM10.5 5.48917L8.16667 7.8225L7.3675 7.02333C7.50167 6.65 7.58333 6.2475 7.58333 5.8275C7.58333 5.74 7.5775 5.65833 7.57167 5.57083L8.16667 6.16583L9.6775 4.655H8.16667V3.48833H10.5C11.1417 3.48833 11.6667 4.01333 11.6667 4.655V6.98833H10.5V5.4775V5.48917Z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="clip0_300_3790">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
